<script setup lang="ts"></script>

<template>
  <div class="footer_details__container">
    <slot name="page"></slot>
  </div>
</template>

<style scoped lang="scss">
.footer_details__container {
  color: var(--text-tertiary-color);
  background: var(--white-main);
  z-index: 100;
}
</style>
